import mutation_new_patient from './new-patient-mutation.graphql.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api'
import { useDataValue, useDataChange } from 'Simple/Data.js'

export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  let [, executeMutationNewPatient] = useMutation(mutation_new_patient)

  let current_location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.id',
  })
  let parent_company_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.parent_company.id',
  })

  let change = useDataChange({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ value, args }) {
    switch (args?.type) {
      case 'add_patient_to_person': {
        let patient_data = {
          patient: {
            organization_id: parent_company_id,
            primary_location_id: current_location_id,
            person_id: args.person_vaxiom_id,
            patient_locations: {
              data: {
                location_id: current_location_id,
              },
            },
            patient_person_referrals: {
              data: [],
            },
            patient_template_referrals: {
              data: [],
            },
          },
        }

        let mutationNewPatientRespone = await executeMutationNewPatient(
          patient_data
        )

        if (mutationNewPatientRespone?.error) {
          notify(
            notifyError(
              'Something went wrong. Please, try again or contact support if the problem persists.'
            )
          )
          return
        }
        let patient_response =
          mutationNewPatientRespone.data?.insert_vaxiom_patients_one

        change(next => {
          next.patient_id = patient_response._id
          next.patient_option = 'existing'
          next.skip_appointment_reset = true
        })
        setFlowTo(normalizePath(props.viewPath, '../No'))

        return
      }
    }
  }
}
